module.exports = __webpack_public_path__ + "img/aiupload.60e71a37.png";